var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloudOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4867 7.25275C17.3123 6.16476 19.4997 5.5 22 5.5C28.7324 5.5 34.3791 10.3201 35.5989 17.9932C37.3502 18.2549 39.1964 18.9176 40.721 20.0834C42.6297 21.543 44 23.775 44 26.8125C44 29.7244 42.924 31.9928 41.0808 33.5206C40.4961 34.0053 39.6293 33.9242 39.1447 33.3395C38.6601 32.7549 38.7411 31.8881 39.3258 31.4034C40.4767 30.4494 41.25 28.9898 41.25 26.8125C41.25 24.7092 40.3429 23.2562 39.0505 22.2679C37.7137 21.2456 35.9341 20.7081 34.3035 20.6231C33.6249 20.5878 33.0739 20.062 33.0067 19.3858C32.305 12.3178 27.4923 8.25 22 8.25C20.004 8.25 18.3019 8.77633 16.8945 9.61506C16.2422 10.0038 15.3982 9.79016 15.0095 9.13783C14.6207 8.48549 14.8344 7.64152 15.4867 7.25275ZM7.61775 14.4441C8.10171 14.2822 8.63556 14.4016 9.00439 14.7543L28.4821 33.3813C28.8881 33.7695 29.0171 34.3656 28.8079 34.887C28.5988 35.4083 28.0935 35.75 27.5318 35.75H11.6875C5.38404 35.75 0 31.3031 0 24.75C0 19.3359 3.36234 15.868 7.61775 14.4441ZM7.72826 17.339C4.78624 18.5779 2.75 21.0406 2.75 24.75C2.75 29.5407 6.64721 33 11.6875 33H24.1045L7.72826 17.339Z",
    fill: "#E58B27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52773 4.52773C5.0647 3.99076 5.9353 3.99076 6.47227 4.52773L39.4723 37.5277C40.0092 38.0647 40.0092 38.9353 39.4723 39.4723C38.9353 40.0092 38.0647 40.0092 37.5277 39.4723L4.52773 6.47227C3.99076 5.9353 3.99076 5.0647 4.52773 4.52773Z",
    fill: "#E58B27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudOrange);
export default __webpack_public_path__ + "static/media/icon-cloud-orange.77e7da9d3d2da81ae9ee09430eae2eb6.svg";
export { ForwardRef as ReactComponent };